<template>
    <div id="message-search">
        <div class="search-bar">
            <div class="material-icons">search</div>
            <input type="text" v-model="query" />
        </div>
        <div class="results">
            <div class="not-found" v-if="query.length <= 0 && !results.length">
                <div class="material-icons">chat_bubble</div>
                <div>Aramak istediğiniz mesaj içeriğini veya gönderen kişinin adını belirtiniz.</div>
            </div>
            <div class="not-found" v-else-if="query.length > 0 && !results.length">
                <div class="material-icons">comments_disabled</div>
                <div>Yakın zamanlarda bir sonuç bulunmadı.</div>
            </div>
            <div class="result-item" v-for="result of results" @click="messageSelected(result)">
                <div class="message" v-html="result.description"></div>
                <div class="footer">
                    <div class="author">{{ result.messageType == "visitor" ? "Visitor" : result.user.name }} -</div>
                    <div class="date">{{ $moment(result.date).format("HH:mm") }}</div>
                </div>
            </div>
            <div class="load-more" @click="loadMore" v-if="(query.length > 0 && !results.length) || results.length > 0">
                <div class="material-icons">search</div>
                Daha fazla göz at
            </div>
        </div>
    </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import _ from "lodash";
import Fuse from "fuse.js";

export default {
    name: "MessageSearch",
    props: {
        conversationId: {
            type: String,
            required: true,
        },
    },
    data: () => ({
        messages: [],
        results: [],
        query: "",
    }),
    computed: {
        ...mapState({
            chatHistory: (state) => state.chat.chatHistory,
        }),
    },
    methods: {
        ...mapActions({
            loadOldHistoryMessages: "chat/loadOldHistoryMessages",
        }),
        search(query) {
            const messages = this.chatHistory[this.conversationId].data.filter((message) =>
                ["visitor", "user"].includes(message.messageType)
            );
            const fuse = new Fuse(messages, { includeScore: true, keys: ["description", "user.name"] });
            return fuse.search(query).map((x) => x.item);
        },
        loadMore() {
            this.loadOldHistoryMessages({
                conversationId: this.conversationId,
                PREFERRED_LIMIT: 100,
            }).then(() => {
                this.results = this.search(this.query);
            });
        },
        messageSelected(message) {
            let messageElement = document.getElementById(`sc-message_${message._id}`);
            if (!messageElement) messageElement = document.getElementById(`sc-message_${message.uniqMessageId}`);
            if (messageElement) messageElement.scrollIntoView();
        },
    },
    watch: {
        query(val) {
            this.results = this.search(val);
        },
    },
};
</script>
<style lang="scss">
#message-search {
    border-radius: 6px;
    background: white;
    height: calc(100vh - 180px) !important;
    width: 100%;
    padding: 20px;
    overflow: auto;

    .search-bar {
        padding-left: 10px;
        border: 1px solid #dddddd;
        display: flex;
        align-items: center;
        border-radius: 6px;
        overflow: hidden;

        input {
            border: none;
            outline: none;
            padding: 10px 10px;
            width: 100%;
        }
    }

    .results {
        margin-top: 20px;

        &:not(:first-child) .result-item {
            margin-top: 5px;
        }

        .not-found {
            display: flex;
            flex-direction: column;
            align-items: center;
            font-size: 21px;
            text-align: center;
            margin-top: 40px;

            .material-icons {
                margin-bottom: 10px;
                font-size: 40px;
            }
        }

        .result-item {
            width: 100%;
            background: rgb(234, 234, 234);
            padding: 10px;
            border-radius: 10px;
            cursor: pointer;

            .footer {
                display: flex;
                align-items: center;
                justify-content: end;
                font-size: 12px;
                color: rgb(34, 34, 34);

                .author {
                    font-weight: bold;
                    margin-right: 5px;
                }
            }
        }
    }

    .load-more {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        font-size: 16px;
        margin-top: 20px;
        cursor: pointer;

        .material-icons {
            font-size: 18px;
            font-weight: bold;
            margin-right: 10px;
        }
    }
}
</style>
